import { BackendError } from 'segments/api/types';
import i18n from 'segments/i18n';

import type { LoginErrors, RegisterErrors } from '../store/types';

import { initialLoginError, initialRegisterError } from './const';


const errorsTranslates: Record<string, string> = {
  'Invalid name': i18n.t('error.invalid-name', 'Неправильное имя пользователя'),
};

export const handleLoginErrors = (status: number, data: BackendError): LoginErrors => {
  const { detail } = data;
  const errors: LoginErrors = { ...initialLoginError };

  if (typeof detail === 'string') {
    if (detail === 'Password incorrect') {
      errors.password = i18n.t('error.password-incorrect', 'Неверный пароль');
    } else if (detail === 'User not found') {
      errors.email = i18n.t('error.user-not-found', 'Пользователь не найден');
    } else {
      errors.common = detail;
    }
  }

  if (Array.isArray(detail)) {
    detail.forEach((err) => {
      const location = err.loc?.[1];
      const message = err.msg;
      if (location === 'email') {
        errors.email = message;
      } else if (location === 'password') {
        errors.password = message;
      } else {
        errors.common = message;
      }
    });
  }
  return errors;
};

export const handleRegisterErrors = (status: number, data: BackendError): RegisterErrors => {
  const { detail } = data;
  const errors: RegisterErrors = { ...initialRegisterError };

  if (typeof detail === 'string') {
    if (detail === 'User exists') {
      errors.email = i18n.t('error.user-exists', 'Пользователь уже зарегистрирован');
    } else {
      errors.common = detail;
    }
  }

  if (Array.isArray(detail)) {
    detail.forEach((err) => {
      const location = err.loc?.[1];
      if (!err.msg) {
        return;
      }
      const message = errorsTranslates[err.msg] || err.msg;

      if ((Object.keys(errors)).includes(location)) {
        errors[location as keyof RegisterErrors] = message;
      } else {
        errors.common = message;
      }
    });
  }

  return errors;
};
